module.exports = __webpack_public_path__ + "assets/img/blender_active.419ee687.png";